import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCyberTerminal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		d: "m5.83 15.175 9.52 5.502-9.52 5.501m20.681 0H16.333M3.461 2A1.453 1.453 0 0 0 2 3.46v25.08A1.453 1.453 0 0 0 3.46 30h25.08A1.45 1.45 0 0 0 30 28.54V3.46A1.45 1.45 0 0 0 28.54 2z"
	})
});
export default SvgCyberTerminal;
